import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid2";

import { 
  Campaign, 
  CampaignNote, 
} from "@dndModels";

import DandDAPI from "@utilities/smart_api";
import { makeStyles } from "@utilities/theme_utilities";

import EditableLabel from "@components/input/strings/EditableLabel";
import DeleteButton from "@components/input/buttons/icon_buttons/DeleteButton";
import ArchiveButton from "@components/input/buttons/icon_buttons/ArchiveButton";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import FlexBox from "@components/layout/FlexBox";
import StringBox from "@components/input/strings/StringBox";

interface Props {
  campaign: Campaign;
  note: CampaignNote;
  onDelete: () => void;
  onArchive: () => void;
}

const api = DandDAPI.getInstance();

export default function CampaignNoteInput({ note, onDelete, onArchive }: Props) {
  const [reloading, setReloading] = useState(false);
  // const [processing, setProcessing] = useState(false);
  const [ping, setPing] = useState(false);
  const [open, setOpen] = useState(note.name.length === 0);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',
        marginBottom: '4px',
      },
    });
  });

  const { classes, cx } = useStyles();

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={open}
        onClose={() => { setOpen(false); }}>
        { renderInputControls() }
      </ModalOrDrawer>
    )
  }

  const renderInputControls = () => {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={12}>
          <EditableLabel
            name="Name"
            value={note.name}
            fontSize={24}
            onChange={ async (changed: string) => {
              note.name = changed;
              api.upsertObject("campaign_note", note);
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid size={12}>
          <StringBox
            name="Details"
            value={note.notes}
            multiline
            onChange={(changed: string) => {
              note.notes = changed;
              api.upsertObject("campaign_note", note);
              setPing(!ping);
            }}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <div className="padded">
      <FlexBox direction="row" className={cx(classes.root, "header")}>
        <FlexBox className="clickable padded" onClick={() => setOpen(true) }>{ note.name }</FlexBox>
        <FlexBox>
          <div style={{ float: "right" }}>
            <ArchiveButton
              no_fab
              is_archived={note.is_archived}
              onClick={onArchive}
            />
            <DeleteButton
              no_fab
              onClick={onDelete}
            />
          </div>
        </FlexBox>
      </FlexBox>
      { renderExtras() }
    </div>
  );
}
